module.exports = __webpack_public_path__ + "static/media/graphic.b3400685.png";